/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require('./bootstrap');

window.Vue = require("vue");

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import Vue from "vue";
// import Vuex from 'vuex'
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.min.css'
import {store} from "./store/store.js"
import router from "./routes/router.js"
import VueCookies from 'vue-cookies'
import VueScrollTo from 'vue-scrollto';
// import IdleVue from 'idle-vue';

Vue.use(VueCookies);
Vue.use(VueScrollTo);
// const eventsHub = new Vue();

// TODO: Fix this. Not getting .env variables in PAT/PROD.
// Vue.use(IdleVue, {
//   eventEmitter: eventsHub,
//   idleTime: (process.env.MIX_SESSION_LIFETIME || 60) * 60000
// });

// register validations
import { extend } from "vee-validate";
import { alpha, alpha_dash, alpha_num, alpha_spaces,digits, email, integer, max, min, mimes, numeric, regex, required, size } from "vee-validate/dist/rules";

extend("alpha", alpha);
extend("alpha_dash", alpha_dash);
extend("alpha_num", alpha_num);
extend("alpha_spaces", alpha_spaces);
extend("digits", digits);
extend("email", email);
extend("integer", integer);
extend("max", max);
extend("min", min);
extend("mimes",mimes);
extend("numeric", numeric);
extend("regex", regex);
extend("required", required);
extend("size", size);
extend("decimal", {
    validate: (value, args) => {
        let decimals = args[0] || '*';
        let separator = args[1] || '.';

        if (value === null || value === undefined || value === '') {
            return {
            valid: false
            };
        }
        if (Number(decimals) === 0) {
            return {
            valid: /^-?\d*$/.test(value),
            };
        }
        const regexPart = decimals === '*' ? '+' : `{1,${decimals}}`;
        const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`);

        return {
            valid: regex.test(value),
        };
    }
});
extend("names", {
    validate: () => {
    const namecheck = new RegExp(`[a-zA-Z]`);

        return {
            valid: namecheck.test(value),
        };
    }
});
extend("url", {
    validate: (value) => {
        return {
            valid: /^(https?:\/\/)?([\w\d-_]+)\.([\w\d-_\.]+)\/?\??([^#\n\r]*)?#?([^\n\r]*)/.test(value),
        };
    }
});

// Vuetify
import vuetify from "./vuetify";

// Plugins
import Chartist from "chartist";

// schema
import { schema } from "./schema.js"

// middleware
import auth from "./middleware/authentication.js"

// plugin setup
// Vue.use(Vuex);
Vue.use(VueRouter);
Vue.use(DashboardPlugin);
Vue.use(VueMaterial);

// programically open dialoges
import MdModalDialog from 'vue-material-modal-dialog';
import 'vue-material-modal-dialog/dist/components.css';
Vue.use(MdModalDialog);

// global library setup
Vue.prototype.$Chartist = Chartist;

import openReplay from './plugins/openReplay'

Vue.config.productionTip = false

Vue.use(openReplay, {
  projectKey: process.env.MIX_OPENREPLAY_PROJECT_KEY || 'QuSvSFcHtinfiduJmob8',
  ingestPoint: process.env.MIX_OPENREPLAY_INGEST_POINT || 'https://openreplay.stage.zink.com.au/ingest'
})


/* eslint-disable no-new */
let vue = new Vue({
    vuetify,
    el: "#app",
    router,
    store,
    mounted() {
        const user = this.$store.getters.user;
        if (user) {
            const newUserId = user.email;
            if (newUserId && this.$tracker) {
                this.$setUserId(newUserId);
            } else if (!this.$tracker) {
                console.warn("OpenReplay tracker is not initialized.");
            } else {
                console.warn(`User Email of user id: ${user.id} is not defined`);
            }
        }
    }
    // onIdle() {
    //     axios.get('/logout')
    //     .then(function (response) {
    //         router.push("/login")
    //     })
    //     .catch(function (error) {
    //         console.log(error);
    //     });
    // },
});

window.vue = vue;
